import { useCallback, useState, useEffect } from 'react';
import { event, ga4Event } from 'analytics';
import { shouldHideTheMenu } from 'utils/toolbar-utils';
import { useSynergyAdapterGA } from 'analytics/config/useSynergyAdapterGA';
import { useRoutes } from 'hooks/routes-hooks';
import { BusinessCategory } from 'constants/synergy';
import { businessCategorySelector } from 'redux/selectors/config';
import { useSelector } from 'react-redux';

const getRootElement = () => document.getElementById('root');

export const useOutsideClickHandler = handleOutsideClick =>
  useEffect(() => {
    getRootElement().addEventListener('click', handleOutsideClick);
    return () =>
      getRootElement().removeEventListener('click', handleOutsideClick, false);
  });

export const useToolbar = stem => {
  const [displayMenu, setDisplayMenu] = useState(false);
  const { getRoute } = useSynergyAdapterGA();
  const { currentPath } = useRoutes();
  const businessCategory = useSelector(businessCategorySelector);

  const handleOutsideClick = useCallback(
    clickEvent => {
      if (
        shouldHideTheMenu({ displayMenu, child: clickEvent.target, stem }) &&
        displayMenu
      ) {
        setDisplayMenu(false);
        event(`${stem}-closed`, stem);
      }
    },
    [setDisplayMenu, displayMenu, stem, stem],
  );

  useOutsideClickHandler(handleOutsideClick);

  const toggleMenu = useCallback(() => {
    setDisplayMenu(!displayMenu);
    event(displayMenu ? `${stem}-closed` : `${stem}-opened`, stem);
    const extraPayload = {};
    if (businessCategory === BusinessCategory.MOTOR) {
      extraPayload.page_name = getRoute(currentPath?.path).page_name;
    }
    if (!displayMenu) {
      ga4Event({
        eventaction: 'display',
        payload: {
          element_clicked: 'menu',
          zone: 'header',
          ...extraPayload,
        },
      });
    }
  }, [setDisplayMenu, displayMenu, stem, stem]);
  return { toggleMenu, displayMenu };
};
